document.addEventListener('click',e=>{const button=e.target.closest('[data-mg-faq] button[data-category]');if(!button)return;const root=button.closest('[data-mg-faq]');root.querySelectorAll('button').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button))});root.querySelectorAll('details[data-category]').forEach(d=>{d.hidden=button.dataset.category!=='all'&&d.dataset.category!==button.dataset.category})});

(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('mg-anim');
  var targets=document.querySelectorAll('.m2-section,.m2-resources,.m2-products,.m2-faq,.m2-newsletter');
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  },{threshold:.1,rootMargin:'0px 0px -60px 0px'});
  targets.forEach(function(el){io.observe(el)});
})();

(function(){
  var header=document.querySelector('.m2-header');
  if(!header)return;
  var announcement=document.querySelector('.m2-announcement');
  var hero=document.querySelector('.m2-hero');
  var main=document.querySelector('main');

  function restingTop(){
    return announcement?announcement.getBoundingClientRect().height:0;
  }
  function layout(){
    if(!header.classList.contains('is-scrolled')){
      header.style.top=restingTop()+'px';
    }
    var h=header.getBoundingClientRect().height;
    if(!hero&&main){
      main.style.paddingTop=h+'px';
    }
  }
  var threshold=24;
  function update(){
    var scrolled=window.scrollY>threshold;
    header.classList.toggle('is-scrolled', scrolled);
    header.style.top=scrolled?'0px':restingTop()+'px';
  }
  layout();
  update();
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', layout);
})();
/* Motion for the black-and-white sections (mgh-, mgd-, mgp-, mgt-, mgc-).
   Blocks below the fold fade up as they scroll into view; grids and lists
   cascade item by item; big numbers count up. Anything already on screen at
   load is left alone so nothing flashes. Skipped entirely for reduced motion. */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(!('IntersectionObserver' in window))return;
  var singles=['.mgh-head','.mgh-statement','.mgh-copy','.mgh-offer','.mgh-rte--page','.mgh-article-cover','.mgh-contact-form','.mgh--numbers .mgh-photo','.mgh--story .mgh-photo','.mgh-product','.mgd-head','.mgd-copy','.mgd-table','.mgd-empty','.mgd-support','.mgd-faq-grid>div:first-child','.mgt-card','.mgt-timeline','.mgt-help','.mgh-filters','.mgd-chips'];
  var groups=['.mgh-cards','.mgh-shop','.mgh-proof-list','.mgh-stats','.mgh-tiers','.mgh-checks','.mgh-versus','.mgh-faq','.mgh-contact-info','.mgd-steps','.mgd-timeline','.mgd-offer','.mgd-cards3','.mgd-fit','.mgd-routine','.mgd-acc','.mgt-steps'];
  var fold=window.innerHeight;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting)land(entry.target);
    });
  },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  function land(el){
    if(!el.classList.contains('mg-rv')||el.classList.contains('mg-in'))return;
    el.classList.add('mg-in');
    io.unobserve(el);
    // Hand the element back to its own hover/transition styles once it has landed.
    setTimeout(function(){el.classList.remove('mg-rv','mg-in');el.style.removeProperty('--mg-d')},900+(parseInt(el.style.getPropertyValue('--mg-d'))||0));
  }
  // Safety net: if the observer ever stays silent, scrolling still reveals what is on screen.
  var last=0;
  function sweep(){
    var now=Date.now();
    if(now-last<120)return;
    last=now;
    var limit=window.innerHeight-40;
    document.querySelectorAll('.mg-rv:not(.mg-in)').forEach(function(el){
      if(el.getBoundingClientRect().top<limit)land(el);
    });
  }
  window.addEventListener('scroll',sweep,{passive:true});
  window.addEventListener('resize',sweep);
  function arm(el,delay){
    if(el.classList.contains('mg-rv'))return;
    if(el.getBoundingClientRect().top<fold)return;
    el.classList.add('mg-rv');
    if(delay)el.style.setProperty('--mg-d',delay+'ms');
    io.observe(el);
  }
  function init(){
    document.documentElement.classList.add('mg-motion');
    singles.forEach(function(sel){document.querySelectorAll(sel).forEach(function(el){arm(el,0)})});
    groups.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(list){
        var items=list.querySelectorAll(':scope > *');
        items.forEach(function(item,i){arm(item,Math.min(i,6)*80)});
      });
    });
    var counter=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        counter.unobserve(entry.target);
        var el=entry.target,m=el.textContent.trim().match(/^(\d+)(.*)$/);
        if(!m||m[1]==='0')return;
        var end=+m[1],rest=m[2],start=null;
        function step(t){
          if(!start)start=t;
          var p=Math.min((t-start)/900,1),e=1-Math.pow(1-p,3);
          el.textContent=Math.round(end*e)+rest;
          if(p<1)requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },{threshold:.6});
    document.querySelectorAll('.mgh-stats dt').forEach(function(el){counter.observe(el)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Quick colour choice on product cards (snippets/mg-product-card.liquid) */
document.addEventListener('click',function(e){var trig=e.target.closest('[data-mgq-open]'),inside=e.target.closest('.mgq');document.querySelectorAll('.mgq:not([hidden])').forEach(function(p){if(p!==inside&&(!trig||p!==trig.nextElementSibling)){p.hidden=true;p.previousElementSibling.setAttribute('aria-expanded','false')}});if(trig){var p=trig.nextElementSibling;p.hidden=!p.hidden;trig.setAttribute('aria-expanded',String(!p.hidden))}if(e.target.closest('.mgq-opt')){var box=e.target.closest('.mgq');setTimeout(function(){box.hidden=true;box.previousElementSibling.setAttribute('aria-expanded','false')},1400)}});
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.mgq:not([hidden])').forEach(function(p){p.hidden=true;p.previousElementSibling.setAttribute('aria-expanded','false')})});

/* Timeline (sections/mg2-pdp.liquid): progress line follows the scroll, each stage lights up when the line reaches it */
(function(){
  var lists=document.querySelectorAll('.mgd-timeline');
  if(!lists.length||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var items=[];
  lists.forEach(function(ol){
    ol.classList.add('is-anim');
    var head=document.createElement('span');head.className='mgd-tl-head';head.setAttribute('aria-hidden','true');ol.appendChild(head);
    items.push(ol);
  });
  var ticking=false;
  function update(){
    ticking=false;
    var vh=window.innerHeight,vertical=window.matchMedia('(max-width:700px)').matches;
    items.forEach(function(ol){
      var r=ol.getBoundingClientRect(),p;
      if(r.bottom<-vh||r.top>vh*2)return;
      p=vertical?(vh*.62-r.top)/r.height:(vh*.85-r.top)/(vh*.45);
      p=Math.max(0,Math.min(1,p));
      ol.style.setProperty('--p',p.toFixed(4));
      ol.classList.toggle('is-moving',p>0&&p<1);
      var lis=ol.querySelectorAll('li'),cur=null;
      lis.forEach(function(li){
        var at=vertical?li.offsetTop/r.height:li.offsetLeft/r.width;
        var on=p>0&&p>=at-0.001;
        li.classList.toggle('is-on',on);
        li.classList.remove('is-cur');
        if(on)cur=li;
      });
      if(cur)cur.classList.add('is-cur');
    });
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update)}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  update();
})();

/* Site-wide motion: add-to-cart flight, animated cart totals and bundle steps, gallery parallax, decimal count-ups. Skipped for reduced motion. */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

  /* 1. The product flies into the cart icon, the icon bumps, then the drawer opens */
  var src=null,srcAt=0;
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-mgc-add],[data-mg-fbt],.product-form__submit,[data-sticky-add]');
    if(b){src=b;srcAt=Date.now()}
  },true);
  function imageFor(b){
    var box=b.closest('.mgh-prod'),img;
    if(box)return box.querySelector('.mgh-prod-img')||box.querySelector('img');
    if(b.closest('.mgp,.mgp-sticky')||b.classList.contains('product-form__submit')){
      var track=document.querySelector('.mgp-hero-track');
      if(track){
        var items=track.querySelectorAll('.mgp-hero-item'),i=Math.round(track.scrollLeft/(track.clientWidth||1));
        img=items[i]&&items[i].querySelector('img');
      }
      return img||document.querySelector('.mgp-hero-item img');
    }
    var li=b.closest('li');
    return li&&li.querySelector('img');
  }
  function bump(){
    var icon=document.getElementById('cart-icon-bubble');
    if(!icon)return;
    icon.classList.remove('mg-bump');icon.offsetWidth;icon.classList.add('mg-bump');
    setTimeout(function(){icon.classList.remove('mg-bump')},600);
  }
  function fly(img,done){
    var icon=document.getElementById('cart-icon-bubble'),a=img.getBoundingClientRect(),t=icon&&icon.getBoundingClientRect();
    if(!t||!a.width||a.bottom<0||a.top>window.innerHeight||!img.animate){done();return}
    var size=Math.min(140,a.width,a.height),x0=a.left+a.width/2-size/2,y0=a.top+a.height/2-size/2;
    var x1=t.left+t.width/2-size/2,y1=t.top+t.height/2-size/2;
    var c=document.createElement('img');c.className='mg-fly';c.src=img.currentSrc||img.src;c.alt='';c.width=size;c.height=size;
    c.style.width=c.style.height=size+'px';document.body.appendChild(c);
    var mx=(x0+x1)/2,my=Math.min(y0,y1)-80;
    var anim=c.animate([
      {transform:'translate('+x0+'px,'+y0+'px) scale(1)',opacity:1},
      {transform:'translate('+mx+'px,'+my+'px) scale(.55)',opacity:1,offset:.55},
      {transform:'translate('+x1+'px,'+y1+'px) scale(.12)',opacity:.4}
    ],{duration:700,easing:'cubic-bezier(.5,0,.25,1)'});
    anim.onfinish=function(){c.remove();bump();done()};
  }
  customElements.whenDefined('cart-drawer').then(function(){
    var C=customElements.get('cart-drawer'),orig=C.prototype.renderContents;
    C.prototype.renderContents=function(state){
      var self=this,b=src,img=b&&Date.now()-srcAt<8000&&!self.classList.contains('active')?imageFor(b):null;
      src=null;
      if(img){fly(img,function(){orig.call(self,state)});return}
      orig.call(self,state);bump();
    };
  });

  /* 2. Cart totals count to their new value; bundle steps fill one after the other */
  var money=['#CartDrawer-Checkout span:last-child','.mgc-save dd','.totals__total-value'],last={},steps={};
  function num(s){var m=(s||'').replace(/,/g,'').match(/-?\d+(\.\d+)?/);return m?parseFloat(m[0]):null}
  function tween(el,from,to){
    var text=el.textContent,f=text.search(/\d/),l=text.search(/\d[^\d]*$/);if(f<0)return;
    var pre=text.slice(0,f),post=text.slice(l+1),dm=text.slice(f,l+1).match(/\.(\d+)$/),dec=dm?dm[1].length:0,start=null;
    el.dataset.mgTween='1';
    function step(t){
      if(!start)start=t;var p=Math.min((t-start)/700,1),v=from+(to-from)*(1-Math.pow(1-p,3));
      el.textContent=pre+v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g,',')+post;
      if(p<1)requestAnimationFrame(step);else{el.textContent=text;delete el.dataset.mgTween}
    }
    el.textContent=pre+from.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g,',')+post;
    requestAnimationFrame(step);
  }
  function scan(first){
    money.forEach(function(sel){
      var el=document.querySelector(sel);if(!el||el.dataset.mgTween)return;
      var v=num(el.textContent);
      if(!first&&v!==null&&last[sel]!=null&&v!==last[sel])tween(el,last[sel],v);
      last[sel]=v;
    });
    document.querySelectorAll('.mgb').forEach(function(bar){
      var key=bar.closest('cart-drawer')?'drawer':'page',on=bar.querySelectorAll('.mgb-steps .is-on'),prev=steps[key]||0;
      if(bar.dataset.mgSeen)return;bar.dataset.mgSeen='1';
      if(!first&&on.length>prev){
        var fresh=[].slice.call(on,prev);
        fresh.forEach(function(li){li.classList.remove('is-on')});
        bar.offsetWidth;
        fresh.forEach(function(li,i){setTimeout(function(){li.classList.add('is-on')},250+i*180)});
      }
      steps[key]=on.length;
    });
  }
  new MutationObserver(function(){scan(false)}).observe(document.body,{childList:true,subtree:true});
  scan(true);

  /* 3. Product gallery: slight parallax and fade while slides move */
  document.querySelectorAll('.mgp-hero-track').forEach(function(track){
    var items=track.querySelectorAll('.mgp-hero-item'),raf=0;
    function paint(){
      raf=0;var w=track.clientWidth||1;
      items.forEach(function(it){
        var d=Math.max(-1,Math.min(1,(it.offsetLeft-track.scrollLeft)/w));
        it.style.setProperty('--mg-px',d.toFixed(3));it.style.setProperty('--mg-pa',Math.abs(d).toFixed(3));
      });
    }
    track.addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(paint)},{passive:true});
    paint();
  });

  /* 4. Count-ups also handle decimals, prices and separators (e.g. 4.8, 10,000+) */
  var counter=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting)return;counter.unobserve(entry.target);
      var el=entry.target,v=num(el.textContent);
      if(v&&!/^\d+\D*$/.test(el.textContent.trim()))tween(el,0,v);
    });
  },{threshold:.6});
  document.querySelectorAll('.mgh-stats dt,[data-mg-count]').forEach(function(el){if(el.getBoundingClientRect().top>window.innerHeight)counter.observe(el)});
})();

/* FAQ page (sections/mg2-faq.liquid): instant search, topic links that follow the scroll */
(function(){
  var root=document.querySelector('[data-mgf]');if(!root)return;
  var input=root.querySelector('[data-mgf-search]'),count=root.querySelector('[data-mgf-count]'),none=root.querySelector('[data-mgf-none]');
  var groups=[].slice.call(root.querySelectorAll('[data-mgf-group]')),links=[].slice.call(root.querySelectorAll('[data-mgf-link]'));
  var qs=[].slice.call(root.querySelectorAll('.mgf-q')).map(function(d){return {el:d,text:d.textContent.toLowerCase().replace(/\s+/g,' ')}});
  var timer;
  input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(filter,120)});
  function filter(){
    var words=input.value.toLowerCase().trim().split(/\s+/).filter(Boolean),shown=0;
    qs.forEach(function(q){
      var ok=words.every(function(w){return q.text.indexOf(w)>-1});
      q.el.hidden=!ok;if(ok)shown++;
      if(words.length&&ok&&shown<=2)q.el.open=true;
      if(!words.length)q.el.open=false;
    });
    groups.forEach(function(g){g.hidden=!g.querySelector('.mgf-q:not([hidden])')});
    none.hidden=shown>0;
    count.textContent=words.length&&shown?shown+(shown>1?' answers':' answer')+' found':'';
  }
  if(!('IntersectionObserver' in window))return;
  var narrow=window.matchMedia('(max-width:989px)');
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      links.forEach(function(a){
        var on=a.getAttribute('href')==='#'+e.target.id;
        a.classList.toggle('is-active',on);
        if(on&&narrow.matches){var ul=a.closest('ul');ul.scrollTo({left:a.offsetLeft-16,behavior:'smooth'})}
      });
    });
  },{rootMargin:'-120px 0px -60% 0px'});
  groups.forEach(function(g){io.observe(g)});
})();

/* Legal pages: Shopify renders policies as a bare container; add a header, "on this page" links, the other policies and a help card */
(function(){
  var box=document.querySelector('.shopify-policy__container');if(!box||box.classList.contains('mgl'))return;
  box.classList.add('mgl');
  var title=box.querySelector('.shopify-policy__title'),body=box.querySelector('.shopify-policy__body');if(!title||!body)return;
  /* Policies pasted in the admin editor have no headings: turn a short first line ("Cost<br>…", "<strong>Cost</strong>") into an h2 */
  (function(){
    var rte=body.querySelector('.rte')||body;
    if(rte.children.length===1&&rte.firstElementChild.tagName==='DIV')rte=rte.firstElementChild;
    if(rte.querySelector('h2')){
      [].slice.call(rte.querySelectorAll('p')).forEach(function(p){if(/is operated by/i.test(p.textContent))p.classList.add('mgl-seller')});
      return;
    }
    var tidy=function(s){return s.replace(/<[^>]+>/g,'').replace(/&nbsp;/g,' ').trim()};
    var isHead=function(s){return s.length>0&&s.length<=60&&!/[.:;,]$/.test(s)&&!/^last updated/i.test(s)};
    var pageTitle=tidy(title.textContent).toLowerCase();
    [].slice.call(rte.children).forEach(function(p,i){
      if(p.tagName!=='P')return;
      var text=tidy(p.innerHTML);
      if(!text){p.remove();return}
      if(i===0&&isHead(text)&&(text.toLowerCase()===pageTitle||/policy$/i.test(text))){p.remove();return}
      var parts=p.innerHTML.split(/<br\s*\/?>/i),head=tidy(parts[0]);
      var h2=document.createElement('h2');
      if(parts.length>1&&isHead(head)){
        h2.textContent=head;p.innerHTML=parts.slice(1).join('<br>').replace(/^\s+/,'');p.parentNode.insertBefore(h2,p);
      }else if(parts.length===1&&isHead(text)&&p.nextElementSibling){
        h2.textContent=text;p.parentNode.replaceChild(h2,p);return;
      }
      if(/is operated by/i.test(p.textContent))p.classList.add('mgl-seller');
    });
  })();
  var eyebrow=document.createElement('p');eyebrow.className='mgl-eyebrow';eyebrow.textContent='Legal';title.insertBefore(eyebrow,title.firstChild);
  var lead=document.createElement('p');lead.className='mgl-lead';var mgMail=(window.mgFacts&&window.mgFacts.supportEmail)||'';lead.innerHTML='Written in plain English. Anything unclear? Email <a href="mailto:'+mgMail+'">'+mgMail+'</a>.';title.appendChild(lead);
  var grid=document.createElement('div');grid.className='mgl-grid';
  var aside=document.createElement('aside');aside.className='mgl-aside';
  var heads=[].slice.call(body.querySelectorAll('.rte h2'));
  if(heads.length>1){
    var toc='<nav class="mgl-toc" aria-label="On this page"><h2>On this page</h2><ol>';
    heads.forEach(function(h,i){if(!h.id)h.id='section-'+(i+1);toc+='<li><a href="#'+h.id+'">'+h.textContent.replace(/</g,'&lt;')+'</a></li>'});
    aside.insertAdjacentHTML('beforeend',toc+'</ol></nav>');
  }
  var links=[].slice.call(document.querySelectorAll('.m2-footer-bottom a[href*="/policies/"]'));
  if(links.length){
    var html='<nav aria-label="Legal pages"><h2>Legal pages</h2><ul>';
    links.forEach(function(a){var here=a.getAttribute('href')===location.pathname;html+='<li><a href="'+a.getAttribute('href')+'"'+(here?' aria-current="page"':'')+'>'+a.textContent+'</a></li>'});
    aside.insertAdjacentHTML('beforeend',html+'</ul></nav>');
  }
  box.insertBefore(grid,body);grid.appendChild(aside);grid.appendChild(body);
  body.insertAdjacentHTML('beforeend','<div class="mgl-help"><div><b>Still have a question?</b><span>A real person replies within 24 hours, Monday to Friday.</span></div><a href="/pages/contact">Contact us</a></div>');
  if(heads.length>1&&'IntersectionObserver' in window){
    var tocLinks=[].slice.call(aside.querySelectorAll('.mgl-toc a'));
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting)return;tocLinks.forEach(function(a){a.classList.toggle('is-active',a.getAttribute('href')==='#'+e.target.id)})})},{rootMargin:'-110px 0px -65% 0px'});
    heads.forEach(function(h){io.observe(h)});
  }
})();

/* Newsletter forms (footer): submit without leaving the page, validate inline, show a clear
   loading state and a success card. Falls back to a normal submit if Shopify asks for a
   captcha. Also tells Klaviyo who signed up. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.m2-footer-form');
    if (!form || form.dataset.mgNative) return;
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    var box = form.closest('.m2-footer-community') || form.parentNode;
    var msg = box.querySelector('.mg-news-msg');
    if (!msg) { msg = document.createElement('p'); msg.className = 'mg-news-msg'; msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite'); form.insertAdjacentElement('afterend', msg); }
    function error(text) { msg.textContent = text; msg.classList.add('is-error'); form.classList.add('is-error'); input.setAttribute('aria-invalid', 'true'); input.focus(); }
    var email = (input.value || '').trim();
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { error('Enter a valid email address, like name@example.com.'); return; }
    msg.textContent = ''; msg.classList.remove('is-error'); form.classList.remove('is-error'); input.removeAttribute('aria-invalid');
    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Joining…';
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (/challenge/.test(res.url)) { form.dataset.mgNative = '1'; form.submit(); return; }
        if (!res.ok) throw new Error('bad');
        return res.text().then(function (html) {
          var dupe = /already|taken/i.test(html) && !/customer_posted=true/.test(res.url);
          window.klaviyo = window.klaviyo || [];
          try { window.klaviyo.push(['identify', { $email: email, newsletter_source: 'footer' }]); } catch (err) {}
          var done = document.createElement('div');
          done.className = 'mg-news-done';
          done.setAttribute('role', 'status');
          done.innerHTML = '<span class="mg-news-tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m5 12 5 5 9-10"/></svg></span><span><b>' + (dupe ? "You're already on the list" : "You're on the list!") + '</b><small>Tips, launches and offers will land at ' + email.replace(/</g, '&lt;') + '. No spam, unsubscribe any time.</small></span>';
          form.replaceWith(done);
          msg.remove();
        });
      })
      .catch(function () {
        btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label;
        error("That didn't go through. Check your connection and try again.");
      });
  });
  document.addEventListener('input', function (e) {
    var form = e.target.closest('.m2-footer-form');
    if (!form || !form.classList.contains('is-error')) return;
    form.classList.remove('is-error');
    var msg = (form.closest('.m2-footer-community') || form.parentNode).querySelector('.mg-news-msg');
    if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
    e.target.removeAttribute('aria-invalid');
  });
})();

/* Back-to-top button with a scroll-progress ring. Shows once the visitor is a screen and a half
   down, or sooner when they start scrolling back up (the moment they want it). Sits above any
   bottom bar (PDP sticky add-to-cart, account tab bar). */
(function () {
  if (document.querySelector('.mg-scroll')) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'mg-scroll';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg class="mg-scroll-ring" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="22"/><circle class="mg-scroll-bar" cx="24" cy="24" r="22" pathLength="100"/></svg><svg class="mg-scroll-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  document.body.appendChild(btn);
  var bar = btn.querySelector('.mg-scroll-bar');
  var lastY = window.scrollY;
  function bottomBars() {
    var h = 0;
    document.querySelectorAll('.mgp-sticky.is-visible, .mgu-nav').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' && cs.display !== 'none') h = Math.max(h, el.getBoundingClientRect().height);
    });
    return h;
  }
  function update() {
    var y = window.scrollY, vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;
    var goingUp = y < lastY - 4;
    var show = max > vh && (y > vh * 1.5 || (goingUp && y > vh * 0.6));
    if (y < vh * 0.6) show = false;
    btn.classList.toggle('is-on', show);
    bar.style.strokeDashoffset = String(100 - Math.min(100, Math.max(0, (y / (max || 1)) * 100)));
    btn.style.setProperty('--mg-scroll-lift', bottomBars() + 'px');
    if (Math.abs(y - lastY) > 4) lastY = y;
  }
  btn.addEventListener('click', function () {
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    var target = document.querySelector('main, #MainContent');
    if (target) { target.setAttribute('tabindex', '-1'); setTimeout(function () { target.focus({ preventScroll: true }); }, smooth ? 500 : 0); }
  });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* Meoggy mascots, placed by context: each pose sits on a real edge where it fits the message
   (the dog bowing over the products, the pair asleep on the footer, walking along the free-delivery bar...).
   One per spot, never over text or the buy button. Decorative: aria-hidden; they appear on scroll and hop on click. */
(function(){
  var M=window.MG_MASCOTS||{};if(!Object.keys(M).length)return;
  var body=document.body,tpl=(body.getAttribute('data-meoggy-template')||'').split('-')[0],path=location.pathname;
  var mobile=window.matchMedia('(max-width:749px)').matches;
  var still=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io='IntersectionObserver' in window&&!still?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -12% 0px'}):null;
  function make(key,cls){
    var m=M[key];if(!m)return null;
    var wrap=document.createElement('span');wrap.className='mg-pet mg-pet--'+m.shape+' '+(cls||'');wrap.setAttribute('aria-hidden','true');
    var img=document.createElement('img');img.src=m.src;img.alt='';img.loading='lazy';img.decoding='async';img.draggable=false;
    wrap.appendChild(img);wrap.insertAdjacentHTML('beforeend','<i class="mg-pet-shadow"></i>');
    wrap.addEventListener('click',function(){wrap.classList.remove('is-hop');void wrap.offsetWidth;wrap.classList.add('is-hop')});
    if(io)io.observe(wrap);else wrap.classList.add('is-in');
    return wrap;
  }
  /* Sits on the top edge of an element (side: left | right | center), or next to it (beside). */
  function place(rule){
    if(mobile&&!rule.mobile)return;
    var el=document.querySelector(rule.sel);if(el&&rule.parent)el=el.parentElement;if(!el||el.querySelector(':scope > .mg-pet'))return;
    if(rule.beside){var p=make(rule.pet,'mg-pet--beside');if(p)el.insertAdjacentElement('afterend',p);return}
    if(getComputedStyle(el).position==='static')el.style.position='relative';
    var pet=make(rule.pet,'mg-pet--edge mg-pet--'+(rule.side||'right'));if(pet){el.appendChild(pet);if(rule.room)el.classList.add('mg-pet-room')}
  }
  var rules=[{sel:'.m2-footer',pet:'duo-07-sommeil',side:'right',mobile:1}];
  if(tpl==='index')rules=rules.concat([
    {sel:'.mgh--shop .mgh-shop',pet:'chien-05-jeu',side:'right',room:1,mobile:1},
    {sel:'.mgh--cards .mgh-cards',pet:'chat-06-toilette',side:'left'},
    {sel:'.mgh-side-us',pet:'chien-02-debout',side:'right'},
    {sel:'.mgh--feature .mgh-product',pet:'duo-03-allonges',side:'center',mobile:1},
    {sel:'.mgh--statement .mgh-btn',pet:'chien-06-patte-levee',beside:1,mobile:1},
    {sel:'.mgh--faq details',parent:1,pet:'duo-06-regard-en-haut',side:'right'}]);
  if(tpl==='product'){
    rules.push({sel:'.mgd--kitpromo .mgd-btn',pet:'duo-01-assis',beside:1,mobile:1});
    if(path.indexOf('pet-hair-removal-gloves')>-1)rules.push({sel:'.mgd--spotlight .mgd-cards3',pet:'chat-01-assis',side:'left',room:1,mobile:1});
    if(path.indexOf('3-in-1-pet-hair-remover-tool')>-1)rules.push({sel:'.mgd--spotlight .mgd-cards3',pet:'chien-04-allonge',side:'left',room:1,mobile:1});
  }
  if(path.indexOf('/pages/about')===0)rules.push({sel:'.mgh--story .mgh-rte h2',pet:'duo-04-nez-a-nez',beside:1,mobile:1});
  if(path.indexOf('/pages/contact')===0)rules.push({sel:'.mgh-contact-form',pet:'chien-01-assis',side:'right',room:1,mobile:1});
  if(tpl==='404')rules.push({sel:'.mgh--shop .mgh-shop',pet:'chien-02-debout',side:'left',room:1,mobile:1});
  if(tpl==='search'){var h1=document.querySelector('.mgsr-head h1');if(h1&&/^Nothing found/.test(h1.textContent.trim()))rules.push({sel:'.mgsr-form',pet:'chat-02-debout',side:'right',mobile:1})}
  rules.forEach(place);

  /* Back-to-top button: the cat walks on top of it (the button is created a moment after load). */
  var tries=0;(function onScrollBtn(){var b=document.querySelector('.mg-scroll');if(!b){if(++tries<20)setTimeout(onScrollBtn,250);return}
    if(!b.querySelector('.mg-pet')){var c=make('chat-03-marche','mg-pet--edge mg-pet--center mg-pet--mini');if(c)b.appendChild(c)}})();

  /* Cart drawer: the pair walks along the free-delivery bar as it fills; a one-off little party when the kit goes in. */
  function cartPets(){
    var drawer=document.querySelector('cart-drawer');if(!drawer)return;
    var bar=drawer.querySelector('.mgc-ship-bar');
    if(bar&&!bar.parentElement.querySelector('.mg-pet--walk')){
      var fill=bar.querySelector('span'),pct=fill?parseFloat(fill.style.width)||0:0;
      var w=make('duo-02-marche','mg-pet--walk');if(w){w.classList.add('is-in');bar.parentElement.style.position='relative';w.style.left='calc('+Math.min(Math.max(pct,0),100)+'% * .86)';bar.insertAdjacentElement('beforebegin',w)}
    }
    var hasKit=[].some.call(drawer.querySelectorAll('.cart-item a[href*="/products/fur-free-home-kit"], .cart-items a[href*="/products/fur-free-home-kit"]'),function(a){return !a.closest('.mgc-addons')});
    try{if(hasKit&&!sessionStorage.getItem('mgKitParty')){sessionStorage.setItem('mgKitParty','1');var head=drawer.querySelector('.drawer__header')||drawer.querySelector('.drawer__inner');
      var p=make('duo-05-jeu','mg-pet--party');if(p&&head){p.classList.add('is-in');head.style.position='relative';head.appendChild(p);setTimeout(function(){p.classList.add('is-gone')},2600)}}}catch(e){}
  }
  cartPets();
  var cd=document.querySelector('cart-drawer');if(cd&&'MutationObserver' in window)new MutationObserver(function(){cartPets()}).observe(cd,{childList:true,subtree:true});
})();

/* Contact storyboard: one stage, scenes follow the visit.
   1 arrival (UK office hours: "We're here" / asleep till the next working morning), 2 typing ("Go on, we're listening"),
   3 order number ("Let's find that parcel"), 4 sent ("Got it!" then "On our way to your inbox"),
   5 hovering the cards ("On its way" / "Quick answers? Look up"). */
(function(){
  var stage=document.querySelector('[data-mgs]');if(!stage)return;
  var pets;try{pets=JSON.parse(stage.getAttribute('data-pets'))}catch(e){return}
  var img=stage.querySelector('.mgs-pet'),bubble=stage.querySelector('.mgs-bubble');
  var still=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  Object.keys(pets).forEach(function(k){var i=new Image();i.src=pets[k]});
  var current=null,timer=null;
  function scene(name,text){
    if(current===name){bubble.textContent=text;return}
    current=name;clearTimeout(timer);
    var swap=function(){stage.setAttribute('data-scene',name);img.src=pets[name];bubble.textContent=text;stage.classList.remove('is-out')};
    if(still){swap();return}
    stage.classList.add('is-out');timer=setTimeout(swap,280);
  }
  /* 1. Arrival: real UK time, because the promise is "within 24 hours, Monday to Friday" */
  function arrival(){
    var parts={};try{new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',weekday:'short',hour:'numeric',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(p){parts[p.type]=p.value})}catch(e){}
    var day=parts.weekday||'Mon',hour=parseInt(parts.hour||'12',10),weekend=day==='Sat'||day==='Sun',open=!weekend&&hour>=9&&hour<18;
    if(open)return scene('here',"We're here.");
    var next=(weekend||(day==='Fri'&&hour>=18))?'Monday':(hour<9?'this morning':'tomorrow morning');
    scene('sleep','Asleep. We’ll reply first thing '+next+'.');
  }
  var form=document.getElementById('MghContact');
  if(form&&form.querySelector('.mgh-form-ok')){
    /* 4. Sent */
    scene('party','Got it!');
    setTimeout(function(){scene('onit','On our way to your inbox.')},still?0:2400);
  }else arrival();
  if(form){
    form.addEventListener('focusin',function(e){
      var f=e.target;if(!f.name)return;
      if(f.name==='contact[order]')scene('parcel','Let’s find that parcel.');
      else scene('listen','Go on, we’re listening.');
    });
    form.addEventListener('focusout',function(){setTimeout(function(){if(!form.contains(document.activeElement)&&!form.querySelector('.mgh-form-ok'))arrival()},150)});
  }
  /* 5. The cards */
  [].forEach.call(document.querySelectorAll('.mgh-contact-info li'),function(li){
    var label=(li.querySelector('b')||{}).textContent||'',key=/order/i.test(label)?'parcel':(/answers/i.test(label)?'curious':null);if(!key)return;
    var text=key==='parcel'?'Tracking it down…':'Most answers are one click away.';
    var on=function(){scene(key,text)},off=function(){if(!form||!form.contains(document.activeElement))(form&&form.querySelector('.mgh-form-ok'))?scene('onit','On our way to your inbox.'):arrival()};
    li.addEventListener('mouseenter',on);li.addEventListener('mouseleave',off);li.addEventListener('focusin',on);li.addEventListener('focusout',off);
  });
})();
/* 2026-10-16: fold long paragraphs on phones behind "Read more" (text stays in the page) */
(function(){
  function fold(){
    if(!window.matchMedia('(max-width:700px)').matches)return;
    document.querySelectorAll('.mgp-info>.mgp-lede, body[data-meoggy-page="collection"] .mgh-intro .mgh-body').forEach(function(p){
      if(p.dataset.mgFold)return; p.dataset.mgFold='1';
      p.classList.add('mg-clamp');
      if(p.scrollHeight<=p.clientHeight+2){p.classList.remove('mg-clamp');return;}
      var b=document.createElement('button');b.type='button';b.className='mg-more-btn';b.textContent='Read more';b.setAttribute('aria-expanded','false');
      b.addEventListener('click',function(){var o=p.classList.toggle('is-open');b.textContent=o?'Read less':'Read more';b.setAttribute('aria-expanded',o?'true':'false');});
      p.insertAdjacentElement('afterend',b);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fold);else fold();
})();

/* Product page videos: nothing downloads on page load; each one loads and plays when it comes near the screen, and pauses when it leaves */
(function(){
  var vids=document.querySelectorAll('video[data-mg-autoplay]');
  if(!vids.length)return;
  function play(v){if(v.dataset.poster&&!v.getAttribute('poster')){v.setAttribute('poster',v.dataset.poster);}var p=v.play();if(p&&p.catch)p.catch(function(){});}
  if(!('IntersectionObserver' in window)){vids.forEach(play);return;}
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){play(e.target);}else if(!e.target.paused){e.target.pause();}
    });
  },{rootMargin:'200px 0px'});
  vids.forEach(function(v){v.muted=true;io.observe(v);});
})();

